import { getResponseErrorCode, withDependencies } from '$lib/api';
import { browser } from '$app/environment';
import { writable, get } from 'svelte/store';
import type { PageLoad } from './$types';

import { getProducts } from '$lib/product';

export const _currentLiveAt = writable(new Date());
export const _ITEMS_RENDERED = 12;

export const load: PageLoad = async ({ fetch, url, parent }) => {
  return withDependencies(async () => {
    const { username, isTestMode, testAppId, profile } = await parent();
    const baseUrl = `https://www.bitski.com/${username}`;
    const pageParam = Number(url.searchParams.get('page'));
    const currentPage = isNaN(pageParam) ? 1 : Math.max(pageParam, 1);

    const offset = (currentPage - 1) * _ITEMS_RENDERED;

    // When in the browser, use the currentLiveAt store which stores the most
    // recent date time. Otherwise, use a new date since we want it to be
    // different for each request.
    const liveAt = new Date(browser ? get(_currentLiveAt) : new Date());

    // Set the time to just after the minute, so we get the correct results
    liveAt.setSeconds(1, 0);

    try {
      const products = await getProducts(fetch, {
        baseUrl,
        offset,
        limit: _ITEMS_RENDERED,
        liveAt,
        isTestMode,
      });

      return {
        products,
        currentPage,
        baseUrl,
        isTestMode,
        testAppId,
        profile,
      };
    } catch (e) {
      const products = getResponseErrorCode(e) === 404 ? [] : undefined;

      return {
        products,
        currentPage,
        baseUrl,
        isTestMode,
        testAppId,
        profile,
      };
    }
  });
};
